module.exports = __webpack_public_path__ + "img/teacher2-4.d549265f.png";